export default {
    radial_bar: {
        referral_status: {
            pending: 'Pending',
            seen_completed: 'Seen/Completed',
            cancelled_no_show: 'Cancelled/No-Show',
            confirmed: 'Confirmed',
        },
    },
}
